import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Calendar, X } from "lucide-react";

export default function MobileCTA() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      // Show after 400px of scroll, hide near footer (last 700px)
      const y = window.scrollY;
      const nearBottom =
        window.innerHeight + y >= document.body.scrollHeight - 700;
      setShow(y > 400 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Hide on the crisis page — sensitive context
  if (location.pathname === "/krisi-panikou" || location.pathname === "/efxaristo") {
    return null;
  }

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = "/#contact";
  };

  return (
    <AnimatePresence>
      {show && !dismissed && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          data-testid="mobile-cta"
          className="md:hidden fixed bottom-4 left-4 right-4 z-40 flex items-center gap-2"
        >
          <button
            onClick={scrollToContact}
            data-testid="mobile-cta-book"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-foreground text-background px-5 py-3.5 font-body text-sm font-medium shadow-[0_10px_40px_rgb(42,54,46,0.25)]"
          >
            <Calendar size={15} strokeWidth={1.5} />
            Κλείσε συνεδρία
          </button>
          <a
            href="tel:+306978042360"
            data-testid="mobile-cta-call"
            className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-[0_10px_40px_rgb(42,54,46,0.2)]"
            aria-label="Κάλεσε"
          >
            <Phone size={16} strokeWidth={1.5} />
          </a>
          <button
            onClick={() => setDismissed(true)}
            data-testid="mobile-cta-dismiss"
            className="inline-flex items-center justify-center w-9 h-12 text-foreground/50"
            aria-label="Κλείσιμο"
          >
            <X size={14} strokeWidth={1.5} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
